/**
 * Public-safe copy for ShopMapViewWizard save catch.
 * Cap / name-conflict keep dedicated i18n; all other failures go through
 * toCustomerFacingErrorMessage (never raw ApiError.message / Invalid JSON).
 */
import { ApiError } from '../../../shared/api/ApiClient.js';
import { toCustomerFacingErrorMessage } from '../../../shared/errors/toCustomerFacingErrorMessage.js';
import { MAP_VIEW_ERROR_CODES } from '../../account/mapViewsTypes.js';

/** i18n keys used by the save-error path (caller supplies `t`). */
export type MapViewWizardSaveErrorT = (key: string) => string;

export function mapViewWizardSaveErrorMessage(
  err: unknown,
  t: MapViewWizardSaveErrorT,
): string {
  if (err instanceof ApiError) {
    if (err.code === MAP_VIEW_ERROR_CODES.VIEW_LIMIT_EXCEEDED) {
      return t('directory.mapView.limitExceeded');
    }
    if (err.code === MAP_VIEW_ERROR_CODES.VIEW_NAME_CONFLICT) {
      return t('directory.mapView.nameConflict');
    }
  }
  return toCustomerFacingErrorMessage(err, {
    fallback: t('directory.mapView.placeSearchError'),
  });
}
